<template>
   <div style="min-height: 300px;">
    <div style="font-size: 35px;font-weight: bold;text-align: center;margin-top: 100px">评价申请进度查询</div>
    <div class="div1">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="统一社会信用代码">
        <el-input v-model="formInline.ecode" placeholder="统一社会信用代码"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="formInline.tel" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">搜索</el-button>
      </el-form-item>
    </el-form>
    </div>
     <div class="searchjg">
       <div  class="gradeX"  v-for="(item,index) in tableData" v-if="item<1" :key="index">

                              <div class="ename" >公司名称:{{tableData.ename}}</div>
                              <div class="ecode">
                              <div class="">统一社会信用代码:{{tableData.ecode}}</div>
                              <div class="">联系人:{{tableData.contacts}}</div>
                              <div class="">联系电话:{{tableData.tel}}</div>
                              <div class="">法定代表人:{{tableData.jperson}}</div>
                              <div class="">地址:{{tableData.eaddr}}</div>
                              <div class="">状态:<label v-if="tableData.state =='1'">完成</label>
                                                  <label v-if="tableData.state =='0'">受理中</label>
                                                  <label v-if="tableData.state =='2'">待受理</label>
                              </div>
                            </div>
         </div>
    </div>
    </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl } from '@/api/index'
export default {
  name: 'authenticationsearch',
  data () {
    return {
      showHeader: false,
      formInline: {
        ecode: '',
        tel: ''
      },
      tableData: [],
      pid: ''
    }
  },
  methods: {
    submitForm (event) {
      let that = this
      // console.log(this.formInline.eCode,this.formInline.tel);
      dataGetUrl(rootPathssb.rootPath + '/app/find?ecode=' + that.formInline.ecode + ',tel=' + that.formInline.tel).then(function (response) {
        if (response.data.result === 1) {
          console.log(response)
          that.tableData = response.data.info
        };

        console.log(response.data)
      }).catch(function (error) {
        console.log(error); alert('失败')
      })
    }
  }
}
</script>

<style scoped>
.div1{
    padding-top: 50px;
    padding-bottom: 10px ;
    width:100%;
    margin:0 auto;
    margin-left: 25%;

}
   .searchjg{
    width: 800px;
    margin: auto;
  }
  .ename{
    font-size: 28px;
    line-height: 35px;
    color: #ff1111;
    margin-bottom: 10px;
  }
  .ecode{
    font-size: 14px;
    color: #888888;
    border-bottom: 1px #999999 solid;
    margin-bottom: 10px;
    line-height: 30px;
  }
  .ecode1{
    padding-right: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/computer/authenticationsearch.vue